import React, { useState, useMemo, useCallback, useEffect } from "react";
import { Badge, Breadcrumb, Card, Col, Divider, Grid, Input, Modal, notification, Popover, Row, Space, Spin, Statistic, Tabs } from 'antd';

import { Box, Typography, Button, Paper, IconButton } from "@mui/material";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import VisibilityIcon from "@mui/icons-material/Visibility";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useDailyJournalMutation, useGetAllNoteQuery, useGetAllTradeQuery, useSaveNoteMutation, useTradelogsMutation } from "../slices/zerodhaApiSlice";
import { setDailyjournal } from "../slices/dailyjournalSlice";
import MyEditor from "./Usercomp/MyEditor";
import DailyTradeDescription from "./Usercomp/DailyTradeDescription";
import AreaGredientChartY from "./Usercomp/AreaGredientChartY";

const TradeCalendar = ({ journalData = [], onOpenNote }) => {




  const { dailyjournal } = useSelector((state) => state.dailyjournal);

  const pageSize = 5; // Cards per page

  const { data: allnotesResponse, isLoading: loadingNotes, isError } = useGetAllNoteQuery();

  const allNotes = allnotesResponse?.data || [];
  // console.log(allNotes);

  const [currentDate, setCurrentDate] = useState(new Date());
  const { darkmode } = useSelector((state) => state.darkmode);
  const bgColor = darkmode ? "#141414" : "#ffffff";
  const cardBg = darkmode ? "#1f1f1f" : "#ffffff";
  const borderColor = darkmode ? "#303030" : "#e5e7eb";

  const profitBg = darkmode ? "#1d6d468c" : "#ecfdf5";
  const lossBg = darkmode ? "#fff1f0" : "#fff1f0";

  const textColor = darkmode ? "#888686" : "#444444";
  const { tradelogs } = useSelector((state) => state.tradelogs);

const [tradeData, setTradeData] = useState([]);

const {data:tradeLogs,isLoading: isTradeLogsLoading } =
  useGetAllTradeQuery();
console.log(tradeLogs);

const { date } = useSelector((state) => state.date);
const tradeLogMap = useMemo(() => {
  const map = {};

  tradeLogs?.trades?.forEach((trade) => {
    const tradeDate =
      trade.closing_date || trade.opening_date;

    if (!tradeDate) return;

    const key = moment(tradeDate).format("YYYY-MM-DD");

    if (!map[key]) {
      map[key] = {
        pnl: 0,
        trades: [],
      };
    }

    map[key].pnl += Number(trade.profit || 0);

    map[key].trades.push(trade);
  });

  return map;
}, [tradeLogs]);  /* ================= TRADE LOG MAP ================= */



  const journalMap = useMemo(() => {
    const map = {};

    [...(journalData || []), ...(allNotes || [])].forEach((j) => {
      const date = j.trade_date || j.date || j._id;
      const key = moment(date).format("YYYY-MM-DD");

      if (!map[key]) map[key] = [];
      map[key].push(j);
    });

    return map;
  }, [journalData, allNotes]);

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();

  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  /* ================= MONTHLY PNL ================= */
  const monthlyPnl = useMemo(() => {
    let total = 0;
    tradelogs?.trades?.forEach((t) => {
      const date = t.closing_date || t.opening_date;
      if (!date) return;

      if (
        moment(date).month() === month &&
        moment(date).year() === year
      ) {
        total += Number(t.profit || 0);
      }
    });
    return total;
  }, [tradelogs, month, year]);

  /* ================= WEEKLY PNL ================= */
  const getWeeklyPnl = (date) => {
    const start = moment(date).startOf("week");
    const end = moment(date).endOf("week");
    let total = 0;

    tradelogs?.trades?.forEach((t) => {
      // if (!t?.closing_date) return;
      // const d = moment(t.closing_date);
      const date = t.closing_date || t.opening_date;
      if (!date) return;
      const d = moment(date);
      if (d.isBetween(start, end, "day", "[]")) {
        total += Number(t.profit || 0);
      }
    });
    return total;
  };

  const getTradeLogByDate = (day) => {
    const dateStr = moment(new Date(year, month, day)).format("YYYY-MM-DD");
    return tradeLogMap[dateStr];
  };
const getNoteByDate = (day) => {
  const dateStr = moment(new Date(year, month, day)).format("YYYY-MM-DD");

  return allNotes?.find(
    (n) => moment(n.trade_date).format("YYYY-MM-DD") === dateStr
  );
};
  // const getJournalByDate = (day) => {
  //   const dateStr = moment(new Date(year, month, day)).format("YYYY-MM-DD");
  //   return journalMap[dateStr];
  // };
  const getJournalByDate = (day) => {
    const dateStr = moment(new Date(year, month, day)).format("YYYY-MM-DD");
 return journalMap[dateStr] || []
  };
  return (
    <Box
  p={2}
  sx={{
    backgroundColor: bgColor,
    borderRadius: 2,
    overflowX: { xs: "auto", md: "visible" }, // allow horizontal scroll on mobile
  }}
>
  {/* Header */}
  {/* <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      mb: 1,
      minWidth: { xs: "600px", md: "100%" }, // ensures header scrolls with calendar
    }}
  > */}
        <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "repeat(8, 120px)", // fixed width columns
            md: "repeat(8, 1fr)",
          },
          // overflowX: { xs: "auto", md: "visible" },
          mb: 1,
        }}
      >
    <Button onClick={() => setCurrentDate(new Date(year, month - 1, 1))}>
      ◀
    </Button>
    <Typography variant="h6">
      {currentDate.toLocaleString("default", { month: "long" })} {year}
    </Typography>
    <Button onClick={() => setCurrentDate(new Date(year, month + 1, 1))}>
      ▶
    </Button>
  </Box>

  {/* Monthly PnL */}
  <Paper
    sx={{
      mb: 2,
      p: 1,
      textAlign: "center",
      backgroundColor: monthlyPnl >= 0 ?profitBg : lossBg,
      color: textColor,
      border: `1px solid ${borderColor}`,
      minWidth: { xs: "600px", md: "100%" }, // scrolls with content
    }}
  >
<Typography
  fontWeight="bold"
  color={
    monthlyPnl >= 0
      ? darkmode
        ? "#9aca9a" // light green in dark mode
        : "green"
      : darkmode
        ? "#ff7b7b" // light red in dark mode
        : "red"
  }
>      Monthly PnL ₹ {monthlyPnl.toFixed(2)}
    </Typography>
  </Paper>

  {/* Calendar grid */}
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: {
        xs: "repeat(8, minmax(120px, 1fr))", // allow shrinking on mobile
        md: "repeat(8, 1fr)",
      },
      gap: 1.5,
      overflowX: { xs: "auto", md: "visible" },
    }}
  >
    {/* Header row */}
    {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Weekly PnL"].map(
      (d) => (
        <Typography
          key={d}
          align="center"
          fontWeight="bold"
          sx={{ color: textColor, minWidth: { xs: "120px", md: "auto" } }}
        >
          {d}
        </Typography>
      )
    )}

    {/* Calendar body */}
    {(() => {
      const weeks = [];
      let dayCounter = 1 - firstDay;

      while (dayCounter <= daysInMonth) {
        const weekDays = [];

        for (let i = 0; i < 7; i++) {
          if (dayCounter < 1 || dayCounter > daysInMonth) {
            weekDays.push(<Box key={`empty-${dayCounter}`} />);
          } else {
            const day = dayCounter;
            const tradeData = getTradeLogByDate(day);
            const journal = getJournalByDate(day);
            const note = getNoteByDate(day);
            const hasNote = (journal && journal.length > 0) || (note && note.length > 0);

            weekDays.push(
              <Paper
                key={day}
                elevation={2}
                sx={{
                  height: { xs: 120, md: 150 },
                  p: 1.5,
                  position: "relative",
                  overflowY: "auto",
                  // backgroundColor: tradeData
                  //   ? tradeData.pnl < 0
                  //     ? "#fff1f0"
                  //     : "#1d6d468c;"
                  //   : cardBg, 
             backgroundColor: darkmode
  ? tradeData
    ? tradeData.pnl >= 0
      ? "#1d6d468c" // dark green
      : "#f6aeae"   // dark red
    : cardBg
  : tradeData
    ? tradeData.pnl >= 0
      ? "#caf9e3"   // light green
      : "#f6dddb"   // light red
    : cardBg,
                  color:textColor,
                  border: `1px solid ${borderColor}`,
                  transition: "0.2s",
                  minWidth: { xs: "120px", md: "auto" }, // responsive
                  "&:hover": { transform: "scale(1.02)" },
                }}
              >
                <Box sx={{ position: "absolute", top: 4, right: 4 }}>
                  <IconButton
                    size="small"
  sx={{ color:textColor }} // White in dark mode, black in light
                    onClick={() => {
                      if (hasNote) {
                        onOpenNote((note && note[0]) || (journal && journal[0]));
                      } else {
                        onOpenNote({
                          trade_date: moment(new Date(year, month, day)).format(
                            "YYYY-MM-DD"
                          ),
                          title: "",
                          content: "",
                        });
                      }
                    }}
                  >
                    {hasNote ? <VisibilityIcon /> : <NoteAddIcon />}
                  </IconButton>
                </Box>

                <Typography fontWeight="bold">{day}</Typography>

                {tradeData && (
                  <Box mt={1}>
                    <Typography
                      fontSize={12}
                      // fontWeight="bold"
color={
  tradeData.pnl >= 0
    ? darkmode
      ? "#d1f4d1" // light green for dark mode
      : "green"
    : darkmode
      ? "#ee4646" // light red for dark mode
      : "red"
}                    >
                      Total ₹ {tradeData.pnl.toFixed(2)}
                    </Typography>

                    {tradeData.trades.map((trade, index) => (
                      <Box key={index} mt={0.5}>
                        <Typography fontSize={10}   sx={{ color: darkmode ? "#2e782e" : "#616b60" }} // White in dark mode, black in light
>
                          {trade.trading_symbol || trade.tradingSymbol || trade.symbol} (
                          {trade.broker?.code || trade.broker_code || "BRK"})
                        </Typography>
                        <Typography
                          fontSize={10}
                          color={Number(trade.profit) >= 0 ?darkmode ? "#2e782e": "green"
    : darkmode
      ? "#ee4646" // light red for dark mode
      : "red"}
                        >
                          ₹ {Number(trade.profit || 0).toFixed(2)}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                )}
              </Paper>
            );
          }
          dayCounter++;
        }

        // Weekly PnL
        const weekEndDate = new Date(year, month, Math.min(dayCounter - 1, daysInMonth));
        const weeklyPnl = getWeeklyPnl(weekEndDate);

        weekDays.push(
          <Paper
            key={`weekly-${dayCounter}`}
            elevation={2}
            sx={{
              height: 150,
              p: 1.5,
              textAlign: "center",
               backgroundColor: darkmode
        ? weeklyPnl >= 0
          ? "#1d6d468c;"   // dark green
          : "#e2c8c8"   // dark red
        : weeklyPnl >= 0
        ? "#caf9e3"     // light green
        : "#f6dddb",    // light red
              
              // backgroundColor: darkmode?weeklyPnl >= 0 ? "#a6f1ce" : "#f6dddb",
              minWidth: { xs: "120px", md: "auto" }, // responsive
            }}
          >
            <Typography fontSize={12} fontWeight="bold"  color={textColor}>
              Weekly
            </Typography>
<Typography
  // fontWeight="bold"
  color={
    weeklyPnl >= 0
      ? darkmode
        ? "#d1f4d1" // light green in dark mode
        : "green"
      : darkmode
        ? "#f78c8c" // light red in dark mode
        : "red"
  }
>              ₹ {weeklyPnl.toFixed(2)}
            </Typography>
          </Paper>
        );

        weeks.push(weekDays);
      }

      return weeks.flat();
    })()}
  </Box>
</Box>

  );

};

export default TradeCalendar;


